import { graphql } from "~/gql";

export const ALL_USERS_QUERY = graphql(/* GraphQL */ `
  query FindAllUsers {
    allUsers {
      id
      userName
      displayName
    }
  }
`);
